export const reviews = [
    {
        Comment: `
We've tried a lot of tools and the integration, flexibility and fast array of features that come with TimeCamp have
really made this tool stand out and pay for itself. It connects to a number of tools we use like our in house project
management tools, our client's project management tools and our accounting software.
`,
        by:"Jakes"
    },
    {
        Comment: `
The primary reason I chose TimeCamp was the direct timekeeping-to-invoicing function, which has been a tremendous
timesaver. I love the way it shows me what I'm spending my time on even when I'm not logging billable hours.
`,
        by:"Kathryn"
    },
    {
        Comment: `
Great asset to managing our marketing agency. We love the ease it takes to input times. We never have to worry about
time record keeping because TimeCamp does it so accurately. It makes creating our invoices at the end of each month so
much easier.
`,
        by:"Review from GetApp.com"
    },
    {
        Comment: `
Our business problem was simple - at any given time we have 20 or so contractors working on a handful of different
projects and we needed to be scientific about knowing how many of whose hours were being spent on which project.
TimeCamp solved this problem well and simply.`,
        by:"Noah"
    }
]